// extracted by mini-css-extract-plugin
module.exports = {"ShopListContainer":"styles_ShopListContainer__3oo8j"};